export const DS_GRID_CLASSES = {
  Root: "ds-grid",
  Layout: "ds-grid__layout",
  LayoutDense: "ds-grid__layout--dense",
  LayoutDivided: "ds-grid__layout--divided",
  Item: "ds-grid__item",
} as const;
